import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import CountDownTimer from '../CountDownTimer';
import {
    POPULAR_EVENT_SCHEDULE_LIVE,
    POPULAR_EVENT_SCHEDULE_INFO,
    POPULAR_EVENT_SCHEDULE_DATE,
    POPULAR_EVENT_SCHEDULE_TIME,
    I18N_POPULAR_EVENT_SCHEDULE_LIVE,
}
from './constants';
import Time from '../../../ui/Time/Time';
import { DATE_TIME_FORMAT_DD_MMM, DATE_TIME_FORMAT_HM } from '~shared/utils/constants';
import { getLocalizedDateFormat } from '~shared/utils/date-time';

import './styles/event-schedule.scss';

import isToday from 'date-fns/is_today';

class EventSchedule extends React.PureComponent {

    static propTypes = {
        startTime: PropTypes.string.isRequired,
        isInplay: PropTypes.bool,
    }

    constructor(props) {
        super(props);
    }

    /**
     * Only show date if it's not today
     * @param {String} startDateTimeString Event start date and time. Format: yyyy-mm-dd hh:mm:ss
     * @returns {Boolean} returns false if event is today.
     */
    showDate(startDateTimeString) {
        return !isToday(new Date(startDateTimeString));
    }

    /**
     * Generates date/time and countdown.
     * @param {String} eventStart Event start date and time.
     *  @param {Boolean} isInplay returns false if event is not inplay.
     * @returns {String} HTML Tag.
     */
    generateDateTime(eventStart, isInplay) {
        let content;

        if (isInplay) {
            content = (
                <div className={`${POPULAR_EVENT_SCHEDULE_LIVE}`}>
                    <Trans>{I18N_POPULAR_EVENT_SCHEDULE_LIVE}</Trans>
                </div>
            );
        } else if (this.showDate(eventStart)) {
            content = <div className={POPULAR_EVENT_SCHEDULE_INFO}>
                        <span className={POPULAR_EVENT_SCHEDULE_TIME}>
                            <Time dateTime={eventStart} format={getLocalizedDateFormat(DATE_TIME_FORMAT_HM)} />
                        </span>
                        <span className={POPULAR_EVENT_SCHEDULE_DATE}>
                            <Time dateTime={eventStart} format={getLocalizedDateFormat(DATE_TIME_FORMAT_DD_MMM)} />
                        </span>
                    </div>;
        } else {
            content = <CountDownTimer scheduledTime={eventStart} />;
        }

        return (
            <div className='bet-card__timer'>
                {content}
            </div>
        );
    }

    render () {

        const dateTime = this.generateDateTime(this.props.startTime, this.props.isInplay);

        return (
            <div>
                {dateTime}
            </div>
        );
    }
}


export default EventSchedule;
